import { render, staticRenderFns } from "./TUDP.vue?vue&type=template&id=61a84fcc&scoped=true&"
import script from "./TUDP.vue?vue&type=script&lang=ts&"
export * from "./TUDP.vue?vue&type=script&lang=ts&"
import style0 from "./TUDP.vue?vue&type=style&index=0&id=61a84fcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a84fcc",
  null
  
)

export default component.exports